import { AuthorizationRequest } from '../../types/AuthorizationRequest';

import { authorizationUrl } from './baseUrl';

import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';

export const generateAuthorizationUrl = (
  appEnv: AppEnv,
  authorizationRequest: AuthorizationRequest,
) => {
  const keyIndex = 0;
  const valueIndex = 1;

  const queryString = Object.entries(authorizationRequest)
    .map((object) => {
      const snakeCaseKey = object[keyIndex]
        .split(/(?=[A-Z])/u)
        .join('_')
        .toLowerCase();
      const value = encodeURIComponent(object[valueIndex]);

      return `${snakeCaseKey}=${value}`;
    })
    .join('&');

  return `${authorizationUrl(appEnv)}?${queryString}`;
};
